const routes = [
  {
    path: '/export',
    name: 'export',
    component: () => import('./index.vue'),
    meta: {
      title: 'Експорт',
      role: ['admin'],
    },
  },
];

export default routes;
